import { createContext, useContext } from 'react';
import { IResultSet } from '../components/carousel/carouselHelpers';

// Define the shape of the data the context will provide.
// It's essentially the return type of your useCarousel hook.
export interface CarouselContextType {
  selectedImageIndex: number;
  selectedImage: IResultSet | null;
  inModal: boolean;
  selectedType: string;
  isPlaying: boolean;
  isUcViewerActive: boolean;
  ucTime: number;
  ucImageSrc: string;
  isWebGL: boolean;
  uniqueImageTypes: string[];
  filteredImages: IResultSet[];
  sortedImages: IResultSet[];
  setSelectedType: (type: string) => void;
  handleGoTo: (index: number) => void;
  handleImageClick: (image: IResultSet) => void;
  handleCloseViewer: () => void;
  handleTogglePlay: () => void;
  setUcTime: (time: number) => void;
  setUcImageSrc: (src: string) => void;
  setInModal: (visible: boolean) => void;
  setIsUcViewerActive: (active: boolean) => void;
}

// Create the context with a default value of undefined.
export const CarouselContext = createContext<CarouselContextType | undefined>(undefined);

// Create a custom hook for easy consumption of the context.
// This is best practice!
export const useCarouselContext = () => {
  const context = useContext(CarouselContext);
  if (context === undefined) {
    throw new Error('useCarouselContext must be used within a CarouselProvider');
  }
  return context;
};